import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  rating: {
    color: '#f9b208',
  },
}))
